/* eslint-disable @typescript-eslint/no-explicit-any */
import { Avatar, Box, Button, Typography } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import ComputerIcon from '@mui/icons-material/Computer';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { ReactElement } from 'react';

const FilePicker = ({
  setUploadedFiles,
  uploadedFiles,
  setErrors
}: {
  setUploadedFiles: (file: any) => void;
  uploadedFiles: any;
  setErrors: (
    value: React.SetStateAction<{
      toolError?: boolean;
      departmentError?: boolean;
      validatorError?: boolean;
      imageError?: boolean;
    }>
  ) => void;
}): ReactElement => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      setErrors({
        imageError: false
      });

      if (
        acceptedFiles[0].size > 1000000 ||
        (acceptedFiles[0].type !== 'image/png' &&
          acceptedFiles[0].type !== 'image/jpeg')
      ) {
        setErrors({
          imageError: true
        });
        return;
      }
      setUploadedFiles(
        acceptedFiles.map((file) => {
          return Object.assign(file, {
            preview: URL.createObjectURL(file)
          });
        })
      );
    }
  });

  const handleRemoveImage = (): void => {
    setUploadedFiles([]);
  };

  return uploadedFiles.length > 0 ? (
    <Box sx={{ position: 'relative', display: 'inline-block', margin: '20px' }}>
      <Avatar
        sx={{
          width: '99px',
          height: '99px',
          borderRadius: '1px',
          backgroundColor: '#A15A0757'
        }}
        imgProps={{
          sx: {
            objectFit: 'contain'
          }
        }}
        src={
          typeof uploadedFiles[0] === 'string'
            ? uploadedFiles
            : uploadedFiles[0].preview
        }
      />
      <Button
        onClick={handleRemoveImage}
        sx={{
          position: 'absolute',
          top: -15,
          right: -30,
          borderRadius: '50%'
        }}
      >
        <DeleteOutlinedIcon
          sx={{
            backgroundColor: '#f4f2fd',
            borderRadius: '50%',
            color: 'red',
            padding: '2px'
          }}
        />
      </Button>
    </Box>
  ) : (
    <Box
      {...getRootProps()}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '5px',
        marginTop: '15px'
      }}
    >
      <input {...getInputProps()} />
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '20px'
        }}
      >
        Drag a Photo Here
      </Typography>
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '20px'
        }}
      >
        -- or --
      </Typography>
      <Box
        sx={{
          border: 1,
          borderColor: '#74777F',
          borderRadius: '8px',
          width: '213px',
          height: '32px',
          marginBottom: '20px'
        }}
      >
        <Box
          sx={{
            margin: '5px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '5px'
          }}
        >
          <ComputerIcon
            sx={{
              color: '#74777F',
              width: '24px',
              height: '16px'
            }}
          />
          <Typography
            sx={{
              color: '#74777F',
              fontSize: '14px',
              lineHeight: '20px',
              fontWeight: 500
            }}
          >
            Upload From Computer
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
export default FilePicker;
